<template>
	<div class="popup">

        <div class="popup-header">
            <div v-if="code.id > 0">
                {{code.land}}
            </div>
            <div v-else>
                 {{ $t("labels.newnationality") }}
            </div>
            <div v-if="code.id == 0" class="popup-close" @click="$emit('close')">
                <font-awesome-icon icon="times" />
            </div>
            <div v-else class="popup-close" @click="save_and_close">
                <font-awesome-icon icon="times" />
            </div>
        </div>
        <div class="popup-body">
            <b-container>
                <form class="form" v-on:submit='save_and_close'>
                    <!-- branche name -->
                    <div class="form-row">
                        <div class="col-3">
                            <font-awesome-icon v-if="checkcode" icon="check" style="color: green;"/>
                            <font-awesome-icon v-else icon="times" style="color: red;"/>                  
                            <label for="">{{ $t("meta.countrycode") }}</label>
                        </div>
                        <div class="col">
                            <b-input ref="deffield" :state="checkcode" type="text" class="form-control" v-model="code.code"></b-input>
                            <b-form-invalid-feedback >
                                {{ $t("validation.landcodenotvalid")}}
                            </b-form-invalid-feedback>  
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-3">
                            <label for="">{{ $t("meta.country") }}</label>
                        </div>
                        <div class="col">
                            <b-input :state="checkcode" type="text" class="form-control" v-model="code.land"></b-input>
                        </div>        
                    </div>  
                
                    <div class="form-row">
                        <div class="col-3">
                            <label for="">{{ $t("titles.nationality") }}</label>
                        </div>
                        <div class="col">
                            <b-input :state="checkcode" type="text" class="form-control" v-model="code.nationality"></b-input>
                        </div>    
                    </div>
                        <div class="form-row">
                        <div class="col-3">
                            <label for="">{{ $t("labels.partofUE") }}</label>
                        </div>
                        <div class="col">
                            <b-form-checkbox  v-model="code.EU"  value="1"
                            unchecked-value="0"></b-form-checkbox> 
                                               </div>                                                
                    </div>                    
                </form>
            </b-container>
        </div>
        <div class="popup-footer">
            <div v-if="code.id == 0" class="btn btn-primary" @click="my_add_code();">{{ addcodeText() }}</div>
            <div v-else @click="save_and_close" class="btn btn-primary">{{ $t("buttons.saveandclose") }}</div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
    name: 'nationality-modal',
    data() {
        return {
            new_code:{id:0, code:"", land:"", nationality:""},
            // nationalities:[]

        }
    },
    props: {
        id: Number,
    },
    async mounted() {
       this.focusInput();
    },
    computed: {
      ...mapState([
      'nationalities',
    ]),
    ...mapGetters([
            'nationality_by_id',
        ]),
        code() {
            return this.id > 0 ? this.nationality_by_id(this.id) : this.new_code
        },
        checkcode(){
          console.log("CHECK", this.code, this.nationalities)
            if(this.code.id>0){
                return true
            }
            let found=false;
            if(this.code.code!=undefined){
                for(var i=0;i<this.nationalities.length;i++){
                    if(this.code.code.toLowerCase()==this.nationalities[i].code.toLowerCase()){
                        found = true;
                        break;
                    }
                }
            }
            console.log(">>>checkcode", found, this.code.code!=undefined, this.code.code.length>=2,this.code)
            return !found &&this.code.code!=undefined&& this.code.code.length>=2
        }        
    },
    methods: {
        addcodeText(){
            if (this.checkcode){
                return this.$i18n.t("buttons.add") 
            } else { 
                return this.$i18n.t("buttons.invalid") 
            }
        },
        save_and_close(e) {
            e.preventDefault() // it prevent from page reload
            if(this.code.id==0){
                this.my_add_code()
            }else{
                this.save_nationality(this.code.id)
                this.$emit('close')
            }            
        },
        ...mapActions([
            'save_nationality',
            'add_nationality'
        ]),
        my_add_code(){
            if(this.checkcode){
                this.add_nationality(this.code);
                this.$emit('close')
            }
        },

    focusInput() {
      this.$refs.deffield.focus();
    }        

    }
}
</script>